import React from 'react';
import MaabarWordmark from './MaabarWordmark';

// The brand lockup, everywhere it appears in the product (navbar, footer, auth,
// loading, tour). It used to be live type — MAABAR | مَعبر stacked over 迈巴尔 —
// which is why this file carried four font-size tables. The identity is now a
// single English wordmark, so the sizes collapse to one number: the height of
// the mark. Width follows from the 1306:204 master, so nothing here can stretch it.
//
// The API is unchanged (as / onClick / size / muted / align) so the eleven call
// sites keep working untouched. `muted` and the currentColor fill are what let
// this stay a component instead of an <img>.
export default function BrandLogo({
  as: Component = 'div',
  onClick,
  size = 'md',
  muted = false,
  align = 'center',
}) {
  const heights = { sm: 20, md: 24, lg: 30, xl: 38 };
  const height = heights[size] || heights.md;
  const Comp = Component;

  return (
    <Comp
      onClick={onClick}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        margin: 0,
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: align,
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
        lineHeight: 1,
        color: muted ? 'var(--text-disabled)' : 'var(--text-primary)',
      }}
    >
      <MaabarWordmark height={height} />
    </Comp>
  );
}
